export default __webpack_public_path__ + "static/media/3435 spice rack B side.0bc1804d.png";